import { render, staticRenderFns } from "./DisplayResultSendMessageGroup.vue?vue&type=template&id=5e1a0d8c&scoped=true"
import script from "./DisplayResultSendMessageGroup.vue?vue&type=script&lang=js"
export * from "./DisplayResultSendMessageGroup.vue?vue&type=script&lang=js"
import style0 from "./DisplayResultSendMessageGroup.vue?vue&type=style&index=0&id=5e1a0d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a0d8c",
  null
  
)

export default component.exports